import React from 'react';
import { useAuth, useUser } from '@clerk/react';
import { Loader2, Lock, ArrowLeft } from 'lucide-react';
import { platform } from '@/platform.config';

export default function SubscriptionShield({ children }: { children: React.ReactNode }) {
  const isLocalhost = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
  const { isLoaded, isSignedIn } = useAuth();
  const { user } = useUser();

  if (isLocalhost) return <>{children}</>;

  if (!isLoaded) {
    return (
      <div className="flex flex-col h-[100dvh] bg-[var(--color-background)] items-center justify-center">
        <Loader2 className="animate-spin text-[var(--color-primary)]" size={48} />
      </div>
    );
  }

  // 1. Not signed in? Direct URL bypass attempt. Bounce them to main site.
  if (!isSignedIn) {
    window.location.href = `${platform.hubUrl}/sign-in`;
    return null;
  }

  // 2. Auth loaded. Check metadata for Subscriptions.
  const metadata = user?.publicMetadata as { stripeSubscriptionStatus?: string, trialExpiresAt?: number };

  let hasAccess = false;

  // Active Stripe Sub
  if (metadata?.stripeSubscriptionStatus === 'active') {
    hasAccess = true;
  }
  // Active Trial
  else if (metadata?.trialExpiresAt && Date.now() < metadata?.trialExpiresAt) {
    hasAccess = true;
  }

  // 3. Render Canvas (Teaser/Active)
  // We no longer block access if isSignedIn. We only block if !isSignedIn.
  return <>{children}</>;
}
